import { Quill } from 'react-quill-new';

const VideoFormat = Quill.import('formats/video');
const BlockEmbed = Object.getPrototypeOf(VideoFormat);

/**
 * Custom blot for uploaded video files (Cloudinary URL).
 * Renders <video> tag for direct video URLs.
 */
class VideoUploadBlot extends BlockEmbed {
  static create(url) {
    const node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', true);
    node.setAttribute('playsinline', true);
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}
VideoUploadBlot.blotName = 'videoUpload';
VideoUploadBlot.tagName = 'VIDEO';
Quill.register(VideoUploadBlot);

export { VideoUploadBlot };
